import { useDispatch, useSelector } from "react-redux";
import { toggleNightMode } from "../../redux/slices/themeSlice";
import { Dropdown } from "react-bootstrap";
import { ToggleOn, ToggleOff, Person } from "react-bootstrap-icons";

export default function UserDropdown({ userAttributes, onSignOut }) {
  const dispatch = useDispatch(); // Initialize the Redux dispatch function
  const nightMode = useSelector((state) => state.theme.nightMode); // Access the current night mode state from Redux

  // Function to handle toggling night mode
  const handleToggleNightMode = () => {
    dispatch(toggleNightMode()); // Dispatch the action to toggle night mode
  };

  return (
    <Dropdown className="d-inline mx-2" autoClose="outside">
      {/* Dropdown toggle button */}
      <Dropdown.Toggle
        id="dropdown-autoclose-outside"
        className="d-flex align-items-center border-0"
        aria-label="User menu"
      >
        <Person className="bi pe-none me-2" width="32" height="32" />{" "}
        {/* User icon */}
        <strong className="d-none d-sm-inline">
          {userAttributes?.name || "My Profile"}
        </strong>{" "}
        {/* Display user's name or "My Profile" */}
      </Dropdown.Toggle>

      {/* Dropdown menu items */}
      <Dropdown.Menu>
        <Dropdown.Item href="/user" aria-label="Go to profile">
          Profile {/* Link to the user's profile */}
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={onSignOut} aria-label="Sign out">
          Sign Out {/* Sign out option */}
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          className="d-flex align-items-center"
          onClick={handleToggleNightMode}
          aria-label="Toggle night mode"
        >
          {/* Toggle icon for night mode */}
          {nightMode ? (
            <ToggleOn className="me-2" width="24" height="24" /> // Show toggle on icon if night mode is active
          ) : (
            <ToggleOff className="me-2" width="24" height="24" /> // Show toggle off icon if night mode is inactive
          )}
          Night mode
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
